<script>
  import { cn } from '@lib/utils'

  let variants = {
    default: 'text-gray-700 text-sm',
    title: 'font-serif font-normal sm:font-light text-2xl sm:text-3xl text-gray-700',
    subtitle: 'text-gray-500/90 text-[15px] sm:text-[16px] max-w-[80ch]',
    section_title: 'text-gray-700 font-medium text-[17px] leading-none',
    detail: 'uppercase text-xs font-medium tracking-wider text-gray-500',
    section_label: 'uppercase text-[11px] tracking-wider font-medium text-gray-400',
    long_text: 'text-gray-600/90 text-[16px] leading-relaxed',
    prose: 'text-gray-600/90 text-[16px] leading-relaxed',
    small_title: 'text-gray-600 font-medium text-[13px] leading-none',
    label: 'text-xs text-gray-500 font-normal',
  }

  let { variant = 'default', as = 'p', text, children, class: className, ...restProps } = $props()

</script>

<svelte:element this={as} class={cn(variants[variant], className)} {...restProps}>
  {#if text}
    {text}
  {:else if children}
    {@render children()}
  {/if}
</svelte:element>